import { Controller } from 'stimulus'

import Rails from '@rails/ujs'
import axios from 'axios'

export default class extends Controller {
  static targets = ['amountsIncludingVatToggle', 'row']
  static values = { totalsUrl: String }

  connect() {
    this.element[this.identifier] = this
    axios.defaults.headers.common['X-CSRF-Token'] = Rails.csrfToken()
  }

  updateTotals() {
    if (!this.hasRowTarget) { return }

    const amountInput = this.rowTarget.querySelector('.input-amount')
    const hasAmountsIncludingVat = this.element.querySelector('.amounts-including-vat').checked
    const items = []
    const vatInput = this.rowTarget.querySelector('.input-vat')

    this.rowTargets.forEach(row => {
      if (row.querySelector('.input-amount') && row.querySelector('.input-vat') && row.style.display != 'none') {
        items.push({
          amount: row.querySelector('.input-amount').value,
          quantity: row.querySelector('.input-quantity').value,
          vat_percentage: row.querySelector('.input-vat').value
        })
      }
    })

    axios.post(
      this.totalsUrlValue,
      {
        amounts_including_vat: hasAmountsIncludingVat,
        items: items
      }
    ).then((response) => {
      Turbo.renderStreamMessage(response.data)
    })
  }
}
